import { themeAtom } from "Infrastructure/Theme/Atom/themeAtom";
import { Box, Container, Stack, styled } from "@mui/material";
import { useAtom } from "jotai";
import type { FC, PropsWithChildren } from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "sonner";

const MainWrapper = styled("div")(() => ({
	display: "flex",
	minHeight: "100vh",
	width: "100%",
}));

export const PageWrapper = styled(Box, {
	shouldForwardProp: (prop) => prop !== "$sidebarWidth",
})<{ $sidebarWidth?: number }>`
  display: flex;
  padding-bottom: 60px;
  flex-direction: column;
  z-index: 1;
  width: ${(props) => `calc(100% - ${props.$sidebarWidth}px)`};
  background-color: transparent;
`;

export const EmptyLayout: FC<PropsWithChildren> = (props) => {
	const [themeConfiguration] = useAtom(themeAtom);

	return (
		<MainWrapper
			className={
				themeConfiguration.activeMode === "dark"
					? "darkbg mainwrapper"
					: "mainwrapper"
			}
		>
			<Toaster richColors position="top-left" />
			<PageWrapper className="page-wrapper" $sidebarWidth={0}>
				<Container
					sx={{
						pt: "30px",
					}}
				>
					<Stack
						sx={{ minHeight: "calc(100vh - 170px)" }}
						position="relative"
						justifyContent="center"
						// alignItems="center"
					>
						{props.children ? props.children : <Outlet />}
					</Stack>
				</Container>
			</PageWrapper>
		</MainWrapper>
	);
};
